module.exports = __webpack_public_path__ + "static/media/Shuppet_gaussian2.8991e885.png";